
import { authEffects } from './login/auth.effects';
import { perfilInicEffects } from './AdmMapa/perfilInic.effects';
import { MapaBaseEffects } from './AdmMapa/MapaBase.effects';
import { redAguaEffects } from './AdmMapa/redAgua.effects';
import { busquedaNissEffects } from './AdmMapa/BusquedaNiss.effects';
import { rangoMPEffects } from './AdmMapa/Modelos/RangoMP.effects';
import { regusrEffects } from './login/regusr.effects';
import { admCartoEffects } from './AdmSiicart/Cartografia/admCarto.effects';
import { admGrpCartoEffects } from './AdmSiicart/Cartografia/admGrpCarto.effects';
import { admModelosEffects } from './AdmSiicart/Modelos/admModelos.effects';
import { admGrpModelosEffects } from './AdmSiicart/Modelos/admGrpModelos.effects';
import { admDatosTEffects } from './AdmSiicart/Modelos/admDatosT.effects';
import { admCamposCEffects } from './AdmSiicart/Modelos/admCamposC.effects';
import { admPerfilEffects } from './AdmSiicart/Perfil/admPerfil.effects';
import { admUsuarioEffects } from './AdmSiicart/Usuario/admUsuario.effects';
import { admEmpresaEffects } from './AdmSiicart/Usuario/admEmpresa.effects';
import { catalogoEffects } from './shared/catalogo.effects';
import { confSceneEffects } from './AdmMapa/Escenarios/ConfScene.effects';
import { SceneEffects } from './AdmMapa/Escenarios/Escenarios.effects';
import { UsersSceneEffects } from './AdmMapa/Escenarios/UsuariosScene.effects';
import { ShareSceneEffects } from './AdmMapa/Escenarios/SceneShare.effects';
import { DUSEffects } from './AdmMapa/Escenarios/EliminarUE.effects';
import { AddSceneEffects } from './AdmMapa/Escenarios/AddScene.effects';
import { DelSceneEffects } from './AdmMapa/Escenarios/EliminarScene.effects';
import { forgotEffects } from './login/forgot.effects';

export const effectsArray: any[] = [
    authEffects,
    forgotEffects,
    perfilInicEffects,
    MapaBaseEffects,
    redAguaEffects,
    busquedaNissEffects,
    rangoMPEffects,
    regusrEffects,
    admCartoEffects,
    admGrpCartoEffects,
    admModelosEffects,
    admGrpModelosEffects,
    admDatosTEffects,
    admCamposCEffects,
    admPerfilEffects,
    admUsuarioEffects,
    admEmpresaEffects,
    catalogoEffects,
    confSceneEffects,
    SceneEffects,
    UsersSceneEffects,
    ShareSceneEffects,
    DUSEffects,
    AddSceneEffects,
    DelSceneEffects
];

export * from './login/auth.effects';
export * from './login/forgot.effects';
export * from './AdmMapa/perfilInic.effects';
export * from './AdmMapa/MapaBase.effects';

export * from './AdmMapa/redAgua.effects';
export * from './AdmMapa/BusquedaNiss.effects';
export * from './AdmMapa/Modelos/RangoMP.effects';
export * from './login/regusr.effects';
export * from './AdmSiicart/Cartografia/admCarto.effects';
export * from './AdmSiicart/Cartografia/admGrpCarto.effects';
export * from './AdmSiicart/Modelos/admModelos.effects';
export * from './AdmSiicart/Modelos/admGrpModelos.effects';
export * from './AdmSiicart/Modelos/admDatosT.effects';
export * from './AdmSiicart/Modelos/admCamposC.effects';
export * from './AdmSiicart/Perfil/admPerfil.effects';
export * from './AdmSiicart/Usuario/admUsuario.effects';
export * from './AdmSiicart/Usuario/admEmpresa.effects';
export * from './shared/catalogo.effects';
export * from './AdmMapa/Escenarios/ConfScene.effects';
export * from './AdmMapa/Escenarios/Escenarios.effects';
export * from './AdmMapa/Escenarios/UsuariosScene.effects';
export * from './AdmMapa/Escenarios/SceneShare.effects';
export * from './AdmMapa/Escenarios/EliminarUE.effects';
export * from './AdmMapa/Escenarios/AddScene.effects';
export * from './AdmMapa/Escenarios/EliminarScene.effects';
